import React, { Component } from 'react';

//Compponent
import FormPasswordReset from '../organisms/FormPasswordReset';


class PasswordReset extends Component {
	render() {
		return (
			<div className="">
			
							<FormPasswordReset

								//Heading & Text
								textHeadingOne={this.props.data.formPasswordReset.textHeadingOne}
								textParagraph={this.props.data.formPasswordReset.textParagraph}

								//Global
								formWrapperClassType=""
								formGroupClassType=""
								textfieldClassType=""
								textFieldForm=""
								textFieldOnChange=""
								errorMessageClassType=""

								//Email
								email={this.props.data.formPasswordReset.email}
								errorMessageEmail={this.props.data.formPasswordReset.errorMessageEmail}

								//Button
								formButtonText={this.props.data.formPasswordReset.formButtonText}
								formButtonClassType=""

								//Back to login
								backToLogin={this.props.data.formPasswordReset.backToLogin}
								href={this.props.data.formPasswordReset.backToLoginHref}
							/>
						</div>
	

		)
	}

}

export default PasswordReset;


// WEBPACK FOOTER //
// ./src/redux/components/templates/PasswordReset.jsx